module.exports = __webpack_public_path__ + "img/img (4).95bde9f1.jpg";